import { complexFaq, mortgageSliders, mortgageShowMore, developerControll, articleDropdown } from './components/misc';

const complexShow = {
    init: function () {
        document.addEventListener('DOMContentLoaded', () => {
            this.complexExcursion();
            this.complexVideoInForm();
            this.generalPlan();
            this.layoutsComplexes();
            this.complexStage();
            this.installmentTabs();
            developerControll();
            complexFaq();
            mortgageSliders();
            mortgageShowMore();
            articleDropdown();
        });
    },

    complexExcursion: function () {
        var groupName = null,
            container = null,
            inGroup = 'no_tag',
            prevGroupName = '';

        $('.complex-excursion__grid-item_main').each(function (index, el) {
            if ((index + 1) % 2 == 0) {
                $(el).addClass('even');
            }
        });

        $('.complex-excursion__grid-item').each(function (index, el) {
            if ($(el).data('group') == inGroup) {
                $(el).attr('data-group', prevGroupName);
            } else {
                if (typeof $(el).data('group') !== 'undefined') {
                    prevGroupName = $(el).data('group');
                }
            }
        });

        $('.complex-excursion__grid-item').on('mouseenter', function (event) {
            if ($(window).width() < 768 || typeof $(this).attr('data-group') == 'undefined') return;

            groupName = $(this).attr('data-group');
            container = $(this).closest('.complex-excursion__grid');

            container.addClass('active');
            $('.complex-excursion__label').removeClass('on-hover');
            container.find('.complex-excursion__grid-item').addClass('disabled');
            container.find(`[data-group=${groupName}]`).removeClass('disabled');
            container.find(`[data-group=${groupName}]`).addClass('active');
            var activeLabel = container.find(`[data-group=${groupName}] .complex-excursion__label`);
            var minText = activeLabel.closest('.complex-excursion__grid-item').data('text-min');
            var maxText = activeLabel.closest('.complex-excursion__grid-item').data('text-max');
            var index = activeLabel.closest('.complex-excursion__grid-item').data('index');
            activeLabel.addClass('on-hover')
            updateTextExcursion(minText, maxText, index);
        });


        $('.complex-excursion__grid').on('mouseleave', function (event) {
            if ($(window).width() < 768) return;
            container.removeClass('active');
            container.find('.complex-excursion__grid-item').removeClass('active disabled');
            $('.complex-excursion__label').removeClass('on-hover');
            updateTextExcursion();
        });

        function updateTextExcursion(textMin = null, textMax = null, index = null) {
            var textMinEl = $('.complex-excursion__grid-item_text-min'),
                textMaxEl = $('.complex-excursion__grid-item_text-max'),
                textMinElSpan = textMinEl.find('span'),
                textMaxElSpan = textMaxEl.find('span');

            var min = textMin ? textMin : textMinEl.data('init');
            var max = textMax ? textMax : textMaxEl.data('init');

            textMinEl.find('span').html(min);
            textMaxEl.find('span').html(max);

            if (groupName) {
                textMinEl.removeAttr('style');
                textMaxEl.removeAttr('style');
                textMinElSpan.removeAttr('style');
                textMaxElSpan.removeAttr('style');
                textMaxEl.next().removeAttr('style');
                var linesInTextMinSpan = Math.floor(parseInt(textMinElSpan.css('height').split('px')[0])
                    / parseInt(textMinElSpan.css('font-size').split('px')[0]));
                var linesInTextMaxSpan = Math.floor(parseInt(textMaxElSpan.css('height').split('px')[0])
                    / parseInt(textMaxElSpan.css('font-size').split('px')[0]));

                var secondMaxBlockTop = 27.8 - ((linesInTextMaxSpan - 0.6) * 1.11);
                var secondMinBlockTop = secondMaxBlockTop - linesInTextMinSpan - 0.8;

                switch (index) {
                    case 1:
                        textMinEl.css({
                            right: '3em',
                            top: '0',
                            width: '32em',
                        });
                        textMinElSpan.css({
                            '-webkit-line-clamp': '2'
                        });
                        textMaxEl.css({
                            right: '3em',
                            width: '32em',
                            top: linesInTextMinSpan >= 2 ? '3.02em' : linesInTextMinSpan === 0 ? '0' : '1.91em',
                            display: 'flex',
                            'padding-left': '0',
                        });
                        textMaxElSpan.css({
                            '-webkit-line-clamp': linesInTextMinSpan >= 2 ? '4' : linesInTextMinSpan === 0 ? '7' : '5'
                        });
                        break;
                    case 2:
                        textMinEl.css({
                            left: '7em',
                            top: secondMinBlockTop + 'em',
                            width: '36em',
                            '-webkit-line-clamp': '2'
                        });
                        textMinElSpan.css({
                            '-webkit-line-clamp': '2'
                        });
                        textMaxEl.css({
                            left: '7em',
                            top: secondMaxBlockTop + 'em',
                            width: '36em',
                            display: 'flex',
                            'padding-left': '0',
                        });
                        textMaxElSpan.css({
                            '-webkit-line-clamp': linesInTextMinSpan >= 2 ? '4' : linesInTextMinSpan === 0 ? '7' : '5'
                        });
                        break;
                    default:
                        textMinEl.css({
                            display: 'flex',
                            'align-items': 'flex-end',
                            width: '10.625em',
                            position: 'relative',
                        });
                        textMaxEl.css({
                            display: 'flex',
                            'align-items': 'flex-end',
                            'margin-left': '6.25em',
                            width: '23.125em',
                            position: 'relative',
                        });
                        textMaxEl.next().css('margin-left', '0');
                        break;
                }
            }
        }

        updateTextExcursion();
    },

    complexVideoInForm: function () {
        if ($('.catalog-form__tablet-inner').length == 0) return;

        $('.catalog-form__tablet-inner').on('click touchend', function () {
            if ($(this).find('iframe').length !== 0) return;

            var youtubeUrl = $(this).data('catalog-video'),
                youtubeUrl = new URL(youtubeUrl);
            youtubeUrl.searchParams.set('enablejsapi', '1');
            youtubeUrl.searchParams.set('autoplay', '1');
            youtubeUrl.searchParams.set('fs', '1');
            youtubeUrl.searchParams.set('loop', '1');
            youtubeUrl.searchParams.set('rel', '0');
            youtubeUrl.searchParams.set('showinfo', '0');
            youtubeUrl.searchParams.set('iv_load_policy', '3');
            let iframe = $(`<iframe src="${youtubeUrl.toString()}" allowfullscreen frameborder="0">`);
            $(this).html('');
            $(this).addClass('play')
            $(this).append(iframe);
        })
    },

    generalPlan: function () {
        $('.general-plan__dot').on('click', function () {
            var cardId = 'render-card-' + $(this).data('dot-id'),
                renderCard;

            $('.general-plan__card').removeClass('show').css('opacity', 0);
            $('.general-plan__dot').removeClass('active');
            if (!$('#' + cardId).length) {
                renderCard = $('#plan-render-card').clone();
                renderCard.attr('id', cardId);
                renderCard.find('.general-plan__card-img img').attr('src', $(this).data('image'));
                renderCard.find('.general-plan__card-desc span').html($(this).data('desc'));

                $(this).after(renderCard);
                renderCard.addClass('show');

                var left = parseFloat($(this).css('left')) - 10,
                    top = parseFloat($(this).css('top')) - 10;

                renderCard.css({
                    left: left,
                    top: top
                });

                if (renderCard.offset().left + renderCard.width() > $(window).width()) {
                    left = left - 75;

                    renderCard.css({
                        left: left,
                    });
                }
            } else {
                renderCard = $('#' + cardId);
            }

            renderCard.addClass('show');
            renderCard.animate({opacity: 1});

            $(this).addClass('active');

            $(this).mouseleave(function () {
                $(document).click(function (event) {
                    if (!event.target.closest('.general-plan__card') && !event.target.closest('.general-plan__dot')) {
                        renderCard.remove();
                    }
                });
            });

        });

        $(document).on('click', function (event) {
            if (!event.target.closest('.general-plan__dot') && !event.target.closest('.general-plan__card')) {
                $('.general-plan__dot').removeClass('active');
            }
        });
    },

    layoutsComplexes: function () {
        if ($(window).width() < 768) return;

        var sliderLayouts = $('#layout-slider'),
            sliderDots = sliderLayouts.siblings('.complex-layouts__dots');

        if ($('.complex-layouts__item').length == 0 || !sliderLayouts) return;

        let movement = false,
            text,
            imagesArr = [];

        function createSlider(images, firstInit = false) {
            if (sliderLayouts.hasClass('flickity-enabled')) {
                sliderLayouts.addClass('hidden');
                sliderLayouts.flickity('destroy');
                sliderDots.flickity('destroy');
            }

            $('.complex-layouts__desc').off('mouseenter');
            $('.complex-layouts__desc').off('mouseleave');

            sliderLayouts.html('');
            sliderDots.html('');

            images.forEach(src => {
                sliderLayouts.append(`<div class="complex-layouts__images-item"><img class="fast_background fb_ev_img_load" data-url="${src}"></div>`);
                if (images.length > 1) {
                    sliderDots.append(`<div class="complex-layouts__dot"></div>`);
                }
            });

            if (images.length > 1) {
                sliderLayouts.flickity({
                    pageDots: false,
                    cellAlign: 'center',
                    contain: true,
                    wrapAround: false,
                    prevNextButtons: false,
                    autoPlay: 2000,
                    pauseAutoPlayOnHover: false
                });

                if (firstInit) {
                    sliderLayouts.flickity('stopPlayer');
                }

                sliderDots.flickity({
                    pageDots: false,
                    cellAlign: 'center',
                    contain: true,
                    wrapAround: false,
                    prevNextButtons: false,
                    draggable: false
                });

                sliderLayouts.on('change.flickity', function(event, index) {
                    sliderDots.flickity('select', index);
                });

                sliderDots.on('change.flickity', function(event, index) {
                    sliderLayouts.flickity('select', index);
                });

                $('.complex-layouts__dot').on('click', function () {
                    sliderLayouts.flickity('select', $(this).index());
                });
            }

            fast_background.update();
        }

        let timer;

        $('.complex-layouts__item').on('mouseenter', function () {
            let item = $(this);
            movement = true;
            clearTimeout(timer);
            timer = setTimeout(function() {
                movement = false;
                createSlider(imagesArr);
                if (item.hasClass('base_schema')) {
                    $('.complex-layouts__images').addClass('base_schema');
                } else {
                    $('.complex-layouts__images').removeClass('base_schema');
                }
                $('.complex-layouts__text span').html(text);
                $('.complex-layouts__desc-container').addClass('show');
                setTimeout(function () {
                    $('.complex-layouts__desc-container').removeClass('hidden show');
                }, 300);
            }, 150);
            switchingLayouts($(this));
        });

        $('.complex-layouts__images').viewportChecker({
            callbackFunction: function(){
                sliderLayouts.flickity('playPlayer');
                sliderLayouts.flickity('next');
            }
        })

        function switchingLayouts(tile, firstInit) {
            var activeLayoutCoords = tile.offset().top - $('.complex-layouts__container').offset().top + tile.height() / 2,
                link = tile.attr('data-link');

            text = tile.attr('data-text');

            $('.complex-layouts__desc-arrow').addClass('show');
            $('.complex-layouts__desc-arrow').css('top', activeLayoutCoords);
            $('.complex-layouts__desc-container').addClass('hidden');
            $('.complex-layouts__desc').attr('href', link);

            imagesArr = tile.data('images').split(',');

            if (firstInit) {
                createSlider(imagesArr, firstInit);
                $('.complex-layouts__desc-container').addClass('show');
                $('.complex-layouts__desc-container').removeClass('hidden show');
            }
        }

        switchingLayouts($('.complex-layouts__item').first(), true);
    },

    complexStage: function () {
        var paddingSide = ($(window).width() - $('.container_center').width()) / 2;

        $('.complex-stage__gallery-container').css('padding-left', paddingSide);
        $('.complex-stage__gallery-container').css('padding-right', paddingSide);

        // получаем массив дивов с данными
        var stageData = jQuery.makeArray($('.complex-stage__data >'));

        if (stageData.length == 0) return;

        // сортируем дивы по годам
        stageData.sort(function (a, b) {
            a = $(a).data('year');
            b = $(b).data('year');
            return a < b ? -1 : a > b ? 1 : 0
        });

        // создаем массив из годов
        var yearArr = stageData.map(function (index, elem) {
            return $(index).data('year');
        });

        // уникализируем массив
        yearArr = new Set(yearArr);
        yearArr = Array.from(yearArr);

        // Создаем объект этапов с сортировкой по годам и месяцам
        var stageObj = {};
        var nodeArr = [];
        stageData.forEach(function (item, i) {
            var year = $(item).data('year');
            var month = $(item).data('month');
            if (typeof stageObj[year] != 'object') {
                stageObj[year] = {};
            }

            nodeArr = stageObj[year][month];
            stageObj[year][month] = [];
        });

        stageData.forEach(function (item, i) {
            stageObj[$(item).data('year')][$(item).data('month')].push(item);
        });

        // Получаем последнюю дату из объекта.
        var lastYear = Math.max(...Object.keys(stageObj));
        var lastMonth = Math.max(...Object.keys(stageObj[lastYear]));
        var currentMonthList = Object.keys(stageObj[lastYear]);

        var monthsList = {
            1: 'Январь',
            2: 'Февраль',
            3: 'Март',
            4: 'Апрель',
            5: 'Май',
            6: 'Июнь',
            7: 'Июль',
            8: 'Август',
            9: 'Сентябрь',
            10: 'Октябрь',
            11: 'Ноябрь',
            12: 'Декабрь',
        };

        // наполняем селект
        for (let year in stageObj) {
            for (let month in stageObj[year]) {
                $('.complex-stage__select-body').append(`
                    <input id="${month}:${year}" type="radio" name="complex-stage" value="${month}:${year}">
                    <label for="${month}:${year}"><span>${monthsList[month]} ${year}</span></label>
                `);
            }
        }

        // Наполняем слайдер актуальными изображениями
        appendStageSlider(stageObj[lastYear][lastMonth]);

        // select
        $(document).click(function (event) {
            var selectContainer = event.target.closest('.complex-stage__select'),
                selectBtn = event.target.closest('.complex-stage__select');
            if (selectContainer) {
                if (selectBtn) {
                    $(selectContainer).toggleClass('active');
                }
            } else {
                $('.complex-stage__select').removeClass('active');
            }

        });

        $('.complex-stage__select-body input').change(function () {
            var selectStageText = $(this).closest('.complex-stage__select').find('.complex-stage__select-btn span'),
                monthStage = $(this).val().split(':')[0],
                yearStage = $(this).val().split(':')[1];

            selectStageText.text(`${monthsList[monthStage]} ${yearStage}`);
            $(this).closest('.complex-stage__select').removeClass('active');

            appendStageSlider(stageObj[yearStage][monthStage]);
        });

        // отмечаем актуальный инпут
        $(`#${lastMonth}\\:${lastYear}`).prop('checked', true).trigger('change');

        // функция наполнения слайдера
        function appendStageSlider(arr) {
            $('.complex-stage__gallery-container').html('').scrollLeft(0);
            arr.forEach(function (item, i) {
                $('.complex-stage__gallery-container').append(`
                     <div class="complex-stage__gallery-item" data-desc="${$(item).data('desc')}" style="animation-delay: ${i / 10}s">
                        <img class="fast_background" data-url="${$(item).data('image')}" alt="stage">
                     </div>
                `);
            });
            if ($(window).width() < 768) {
                main.customMobileScrollBar($('.complex-stage__gallery-container').closest('.scroll__wrapp'));
            }
            fast_background.update();
        }

        var staticClickFlag = false;

        $(document).on('mousedown touchstart', '.complex-stage__gallery-item', function () {
            staticClickFlag = true;
        });
        $(document).on('mousemove ontouchmove', '.complex-stage__gallery-item', function () {
            staticClickFlag = false;
        });
        $(document).on('mouseup touchend', '.complex-stage__gallery-item', function () {
            if (staticClickFlag) {
                fillSimpleGallery($(this).index());
            }
        });

        function fillSimpleGallery(indexScroll) {
            var imageObj = {};
            $('.complex-stage__gallery-item').map(function (index, item) {
                return $(item).find('.fast_background').data('url');
            })

            $('.complex-stage__gallery-item').each(function (index, item) {
                imageObj[index] = {};
                imageObj[index]['src'] = $(item).find('.fast_background').data('url');
                imageObj[index]['desc'] = $(item).data('desc');
            });

            $('.modal__simple-gallery__list').html('');

            for (let key in imageObj) {
                $('.modal__simple-gallery__list').append(`
                    <div class="modal__simple-gallery__item ${key == indexScroll ? 'scroll-here' : ''}">
                        <div class="modal__simple-gallery__image">
                            <img class="fast_background" data-url="${imageObj[key]['src'] ? imageObj[key]['src'] : ''}" alt="stage">
                        </div>
                        <div class="modal__simple-gallery__desc">
                            <span>${imageObj[key]['desc'] ? imageObj[key]['desc'] : ''}</span>
                        </div>
                    </div>
                `);
            }

            popupActions.popupShow('simple-gallery', false, true);
        }
    },

    installmentTabs: function() {
        if ($('.installment-plan__controll').length == 0) return;

        function toggleInstallment() {
            var activeCheckbox = $('.installment-plan__controll input:checked');
            var val = activeCheckbox.val();

            $('.installment-plan__controll label span').animate({width: 'hide'}, 300);
            $(`.installment-plan__controll label[for="${activeCheckbox.attr('id')}"]`).find('span').animate({width: 'show'}, 300);
            $('.installment-plan__tab').addClass('hidden');

            setTimeout(function () {
                $('.installment-plan__tab').removeClass('show hidden');
                $(`.installment-plan__tab[data-installment-tab="${val}"]`).addClass('show');
            }, 400)
        }

        toggleInstallment();

        $('.installment-plan__controll input').on('change', function () {
            toggleInstallment();
        })

    },
};

complexShow.init();